import React, { useState, useEffect, useContext } from "react";
import "./Qrtemplate.scss";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector, useDispatch } from "react-redux";
import {
  changeTemplateActions,
  getTemplateId,
  templateGetParticularActions,
} from "../../Store/Actions/TemplateActions";
import { headerFixed, headerStatic } from "../../Store/Actions/HeaderActions";
import { resumeEditActions } from "../../Store/Actions/ResumeActions";
import { useParams } from "react-router";
import { TemplateContext } from "../../Context/templateContext";
import WarningPopup from "../Modals/AppTemplateWarningPopup/WarningPopup";
// import Picktemplate from "../../Components/Picktemplate/Picktemplate";

/**
 *  need to show the template part here
 *  when clicked need to show the transparant popup  (pick a sample cloning)
 *
 */

function Qrtemplate({ setOverflow, setZindex, urlname, showTemplateNewPopup }) {
  const { id } = useParams();
  const path = window.location.pathname;
  const [tempData, setTempData] = useState("");
  const [templateId, setTemplateId] = useState("");
  const [image, setImage] = useState();

  const getTemplate = useSelector((state) => state.templateList);
  const editorData = useSelector((state) => state.editorData);
  const templateData = useSelector((state) => state.TemplateParticular.data);
  const coverData = useSelector((state) => state.CoverTemplateParticular.data);
  const resume = useSelector((state) => state.resumeGetById.resume);

  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [samplemodalShow, setsamplemodalShow] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [getTemplateData, setGetTemplateData] = useState("");

  //Template Popup
  const { showTemplate, setShowTemplate } = useContext(TemplateContext);

  useEffect(() => {
    if (path && path.includes("coverletter")) {
      setTempData(coverData);
    } else {
      setTempData(templateData);
    }
  }, [templateData, coverData]);

  useEffect(() => {
    let temp_image;
    if (tempData && tempData.image_compressed) {
      setImage(tempData?.image_compressed);
    }
  }, [tempData]);

  function onresumeHide() {
    setModalShow(false);
  }

  useEffect(() => {
    setGetTemplateData(getTemplate);
  }, [getTemplate]);

  useEffect(() => {
    setTemplateId(resume);
  }, [resume]);

  function sampleHide() {
    const data = {
      main: {
        position: "fixed",
        width: "100%",
        zIndex: 999,
        top: 0,
      },
      sub: {
        position: "fixed",
        width: "100%",
        zIndex: 99,
        top: "55px",
      },
    };
    setsamplemodalShow(false);
    // setOverflow({ position: "static", zIndex: 0 });
    // history.push(`/resumes/${id}`);
    dispatch(headerFixed(data));
  }
  function showsample() {
    if (tempData && tempData.status && tempData.status == "2") {
      setShowWarningPopup(true);
    } else {
      setShowTemplate(true);
      showTemplateNewPopup();
      setsamplemodalShow(true);
      setModalShow(false);
      // setOverflow({ position: "relative", zIndex: -1 });
    }
    // dispatch(headerStatic(data));
  }

  const changeTemplate = (responseId) => {
    const body = {
      title: "this resume template",
      body: "Body",
      content: JSON.stringify(editorData),
      completed: false,
    };

    dispatch(getTemplateId(responseId));
    dispatch(changeTemplateActions(responseId));
    dispatch(resumeEditActions(id, body));
  };

  useEffect(() => {
    if (urlname == "?new") {
      setShowTemplate(true);
      // setOverflow({ position: "relative", zIndex: -1 });
    }
  }, [urlname]);

  useEffect(() => {
    const data = {
      main: {
        position: "static",
      },
      sub: {
        position: "static",
      },
    };
    if (window.location.search === "?new") {
      // dispatch(headerStatic(data));
    }
  });
  const handleHideWarning = () => {
    setShowWarningPopup(false);
  };
  const showTemplatePopup = () => {
    setShowTemplate(true);
    showTemplateNewPopup();
    setsamplemodalShow(true);
    setModalShow(false);
    // setOverflow({ position: "relative", zIndex: -1 });
    setShowWarningPopup(false);
  };

  return (
    <>
      <WarningPopup
        show={showWarningPopup}
        hide={handleHideWarning}
        showTemplatePopup={showTemplatePopup}
      />
      <div className="qr-container" onClick={showsample}>
        <img className="w-100" src={image && image} />
        <div className="qrsection">
          <label>Current Template</label>
          <Dropdown drop="down">
            <Dropdown.Toggle
              variant="white"
              id="dropdown-basic"
              className="qrdrpdown "
            >
              <img
                className="qr-template-img"
                src="images/qr-1.svg"
                style={{ width: "12px", margin: "3px 10px 0 0px" }}
              />
              {tempData && tempData.name}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {getTemplateData &&
                getTemplateData.template &&
                getTemplateData.template.map((response) => (
                  <Dropdown.Item
                    className="text-capitalize"
                    // onClick={() => changeTemplate(response.id)}
                  >
                    {response?.name}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      {/* {samplemodalShow ? <Picktemplate samplehide={sampleHide} setOverflow={setOverflow}/> : ""} */}
    </>
  );
}

export default Qrtemplate;
